<template>
  <button
    :class="cssClass"
    @click="handleClick"
  >
    <img
      :src="imgsrc"
      alt="back"
      width="24"
    >
  </button>
</template>

<script>
import WhiteArrow from '../assets/back-arrow.png'
import BlackArrow from '../assets/back-arrow-blk.png'

export default {
  name: 'BackButton',
  props: {
    cssClass: {
      type: String,
      default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
  },
  computed: {
    imgsrc () {
      return this.cssClass === 'reverse' ? BlackArrow : WhiteArrow
    }
  },
  methods: {
    handleClick() {

      // Not specified? Be a back button
      if (!this.backLink) {
        this.$router.go(-1)
      }

      // String? Check for a fully qualified URL. If found,
      // skip the router and directly navigate.
      if (typeof this.backLink == 'string') {
        if (/^https?:\//.test(this.backLink)) {
          window.location.href = this.backLink
          return
        } else {
          this.$router.push(this.backLink)
          return
        }
      }

      // Fall back to just pushing the link, just in case
      this.$router.push(this.backLink)
    }
  }
}
</script>
